import { jsx as _jsx } from "react/jsx-runtime";
import { View } from 'react-native';
import { MultiOfferCard, SingleOfferCard } from './components';
import { getTestId } from '@airtel/air-design-system';
export var OfferCardWidgetComponent = props => {
  var _props$listData = props.listData,
    listData = _props$listData === void 0 ? [] : _props$listData,
    testID = props.testID,
    containerStyle = props.containerStyle;
  return _jsx(View, Object.assign({
    style: containerStyle
  }, {
    children: (listData === null || listData === void 0 ? void 0 : listData.length) > 1 ? _jsx(MultiOfferCard, Object.assign({}, getTestId(testID + '_multiOfferCard'), props)) : _jsx(SingleOfferCard, Object.assign({}, getTestId(testID + '_singleOfferCard'), props))
  }));
};
OfferCardWidgetComponent.genericRendererKey = 'AirOfferCardWidget';